export enum AuthenticationActions {
    Login = 0,
    ForgetPassword = 1,
    VerifyEmail = 3,
    ChangeMobile = 4,
    ChangePassword = 5
  }


  export enum VendorType {
    Individual = 'Individual',
    Organization = 'Organization',
    Investor = 'Investor',
  }

  export enum TypeofTender {
    Public = 'Public',
    Private = 'Limited',
  }



  export enum TenderAction {
    Accpet = 'Accept',
    Reject = 'Reject',
    AccpetjoiningFee = 'AccpetjoiningFee'
  }


  

  export enum BidStatus {
    Draft = 'Draft',
    Submitted = 'Submitted',
    Withdrawn = 'Withdrawn',
    Regret = "Regret",
    Awarded = "Awarded",
    Rejected = "RejectedParticipation",
    PaymentVerificationPending = "PaymentVerificationPending"
  }


  export class BidDetailsComponent {
    BidStatus = BidStatus; // Enum reference for template use
    bidStatuses = Object.values(BidStatus); // Array of statuses from enum
    selectedStatus: string | null = null; // Holds the currently selected status
  }

  



  


  export enum VendorStatus {
    Draft = 'Draft',
    Submitted = 'Submitted',
    InReview = 'InReview',
    Approved = 'Approved',
    Rejected = 'Rejected',
    ChangeRequested = 'ChangeRequested'
  }
  

  export enum IconType {
    Success = 'bi-check-circle', // Success icon
    Warning = 'bi-exclamation-triangle', // Warning icon
    Error = 'bi-x-circle', // Error icon
  }

  export enum DocumentProcessTypes {
    Vendor = 'Vendor',
    VendorBank = 'VendorBank',
    Tender = 'Tender',
    Bidding = 'Bidding',
    PurchaseOrder = 'PurchaseOrder',
    PurchGRN = 'PurchGRN',
    PurchInvoice = 'PurchInvoice',
    PurchPayment = 'PurchPayment',
  }
  

  export enum TenderClassification {
    RFP = 'RFP',
    RFQ = 'RFQ',
    Variation = 'Variation',
  }

  
  export enum DocumentCategoryType {
    AwardLetter = 'Letter of Award',
    RegretLetter = 'Letter of Regret',
    PerformanceBond = 'Performance bond',
    TenderBond = 'Tender Bond',
    RFP = 'RFP',
    RFQ = 'RFQ',
    OtherDocuments = 'OtherDocuments',
  }

  
  